export function getVolumeLevel(percent: string): number {
  const rg = /(?<digits>\d+).*/;
  const results = rg.exec(percent);

  const digitsString = results?.groups?.digits;
  const digits = digitsString ? Number(digitsString) : -1;
  if (digits >= 0 && digits <= 100) {
    return digits / 100;
  }
  return -1;
}
